module.exports = __webpack_public_path__ + "img/progress-icon.9175d6fa.svg";